export const scrollToId = (id) => {
  const el = document.querySelector(id);
  if (!el) return;
  if (window.__lenis) {
    window.__lenis.scrollTo(el, { offset: -72, duration: 1.4 });
  } else {
    el.scrollIntoView({ behavior: "smooth" });
  }
};

export const BRAND = {
  phone: "+91 96638 47710",
  email: "nexorbitsolutions@gmail.com",
  address: "Emmanuel Heights 1A, 206 Amrita Nagar, Hosa Road, Kasavanahalli, Bangalore 560099",
};
